[
  {
    "id": "TB-E7-001",
    "module": "Taalbegrip",
    "difficulty": 205,
    "question": "Lees de tekst:\n\n\"De menselijke hersenen wegen maar 1,4 kilo, toch verbruiken ze 20% van alle energie die je lichaam nodig heeft. Dat is meer dan welk ander orgaan ook. De hersenen werken zelfs als je slaapt.\"\n\nWat maakt de hersenen bijzonder volgens deze tekst?",
    "options": ["Ze verbruiken heel veel energie voor hun gewicht", "Ze wegen 1,4 kilo", "Ze zijn het grootste orgaan", "Ze werken alleen overdag"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-HERSENEN",
    "explanation": "De tekst benadrukt het contrast: licht (1,4 kg) maar veel energieverbruik (20%). Het signaalwoord 'toch' markeert dit contrast.",
    "distractorExplanations": {
      "1": "Het gewicht is een feit, maar niet wat ze bijzonder maakt.",
      "2": "De tekst zegt niet dat ze het grootste orgaan zijn.",
      "3": "De tekst zegt juist dat ze ook tijdens het slapen werken."
    }
  },
  {
    "id": "TB-E7-002",
    "module": "Taalbegrip",
    "difficulty": 205,
    "question": "Lees de tekst:\n\n\"Steeds meer jongeren kiezen voor een vegetarisch dieet. Ze doen dit om verschillende redenen: dierenwelzijn, het milieu en gezondheid. Critici waarschuwen echter dat je goed moet opletten dat je genoeg eiwitten binnenkrijgt.\"\n\nWelke drie redenen worden genoemd voor vegetarisch eten?",
    "options": ["Dierenwelzijn, milieu en gezondheid", "Smaak, prijs en gemak", "Gezondheid, mode en religie", "Milieu, smaak en traditie"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-VEGETARISCH",
    "explanation": "De tekst somt drie redenen op na de dubbele punt: 'dierenwelzijn, het milieu en gezondheid'.",
    "distractorExplanations": {
      "1": "Smaak, prijs en gemak worden niet genoemd.",
      "2": "Mode en religie worden niet genoemd.",
      "3": "Smaak en traditie worden niet genoemd."
    }
  },
  {
    "id": "TB-E7-003",
    "module": "Taalbegrip",
    "difficulty": 205,
    "question": "Wat betekent het woord 'optimistisch' in de zin: 'De dokter is optimistisch over het herstel.'",
    "options": ["Positief gestemd, verwacht dat het goed komt", "Bezorgd, verwacht problemen", "Onzeker, weet het niet", "Boos, vindt het slecht"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-OPTIMISTISCH",
    "explanation": "'Optimistisch' betekent positief ingesteld. De dokter verwacht dat het herstel goed zal verlopen.",
    "distractorExplanations": {
      "1": "Dat zou 'pessimistisch' zijn.",
      "2": "Dat zou 'twijfelachtig' zijn.",
      "3": "Boos is een andere emotie."
    }
  },
  {
    "id": "TB-E7-004",
    "module": "Taalbegrip",
    "difficulty": 205,
    "question": "Lees de tekst:\n\n\"De eerste computer woog 30 ton en vulde een hele kamer. Tegenwoordig past een veel krachtigere computer in je broekzak. In de toekomst worden computers waarschijnlijk nog kleiner en sneller.\"\n\nWat is de tekststructuur?",
    "options": ["Verleden → heden → toekomst (tijdsvolgorde)", "Probleem → oplossing", "Oorzaak → gevolg", "Mening → argument"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "tekststructuur",
    "familyId": "TB-STRUCTUUR-COMPUTER",
    "explanation": "De tekst beschrijft drie tijdperiodes: verleden ('de eerste computer'), heden ('tegenwoordig') en toekomst ('in de toekomst').",
    "distractorExplanations": {
      "1": "Er wordt geen probleem opgelost.",
      "2": "Er is geen oorzaak-gevolg relatie.",
      "3": "Er wordt geen mening verdedigd."
    }
  },
  {
    "id": "TB-E7-005",
    "module": "Taalbegrip",
    "difficulty": 205,
    "question": "Tik op het woord waar 'ervan' naar verwijst.",
    "options": ["plastic tassen"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "Plastic tassen", "id": "s1", "isCorrect": true },
        { "text": " worden in steeds meer landen verboden. In ", "id": "s2", "isTappable": false },
        { "text": "Kenia", "id": "s3" },
        { "text": " staat er zelfs ", "id": "s4", "isTappable": false },
        { "text": "gevangenisstraf", "id": "s5" },
        { "text": " op het gebruik ", "id": "s6", "isTappable": false },
        { "text": "ervan", "id": "s7", "isHighlighted": true, "isTappable": false },
        { "text": ". ", "id": "s8", "isTappable": false },
        { "text": "Nederland", "id": "s9" },
        { "text": " koos voor een andere aanpak: hier betaal je voor een plastic tas.", "id": "s10", "isTappable": false }
      ],
      "feedbackMap": {
        "s1": "Goed! 'Het gebruik ervan' = het gebruik van plastic tassen.",
        "s3": "Kenia is de locatie, niet waar 'ervan' naar verwijst.",
        "s5": "Gevangenisstraf is de straf, niet het onderwerp van 'ervan'.",
        "s9": "Nederland wordt pas in de volgende zin genoemd."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-PLASTIC",
    "explanation": "'Het gebruik ervan' = het gebruik van plastic tassen. 'Ervan' verwijst terug naar plastic tassen.",
    "distractorExplanations": {
      "2": "Kenia is de locatie, niet waar 'ervan' naar verwijst.",
      "4": "Gevangenisstraf is de straf, niet het onderwerp van 'ervan'.",
      "8": "Nederland wordt pas in de volgende zin genoemd."
    }
  },
  {
    "id": "TB-E7-006",
    "module": "Taalbegrip",
    "difficulty": 205,
    "question": "Lees de tekst:\n\n\"De Bermudadriehoek staat bekend als een mysterieus gebied waar schepen en vliegtuigen verdwijnen. In werkelijkheid verdwijnen er niet meer schepen dan in andere drukbevaren gebieden. Het mysterie is grotendeels een mythe.\"\n\nWat wil de schrijver duidelijk maken?",
    "options": ["Dat het mysterie van de Bermudadriehoek overdreven is", "Dat de Bermudadriehoek heel gevaarlijk is", "Dat je er niet moet varen", "Dat schepen vaak verdwijnen op zee"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "doel_schrijver",
    "familyId": "TB-BERMUDA-DOEL",
    "explanation": "De schrijver weerlegt het mysterie: 'In werkelijkheid... niet meer' en 'grotendeels een mythe'. Hij wil laten zien dat het overdreven is.",
    "distractorExplanations": {
      "1": "De tekst zegt juist dat het niet gevaarlijker is dan andere gebieden.",
      "2": "De tekst waarschuwt niet, maar ontkracht het mysterie.",
      "3": "De tekst zegt dat er niet meer schepen verdwijnen dan elders."
    }
  },
  {
    "id": "TB-E7-007",
    "module": "Taalbegrip",
    "difficulty": 205,
    "question": "Welk signaalwoord past het best?\n\n\"De film was heel populair. ... vonden de critici hem slecht.\"",
    "options": ["Toch", "Daarom", "Bovendien", "Want"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-TOCH-FILM",
    "explanation": "'Toch' geeft een tegenstelling aan: populair bij het publiek, maar slecht volgens critici.",
    "distractorExplanations": {
      "1": "'Daarom' zou een logisch gevolg zijn, maar slechte recensies zijn geen logisch gevolg van populariteit.",
      "2": "'Bovendien' voegt iets toe van dezelfde soort.",
      "3": "'Want' geeft een reden."
    }
  },
  {
    "id": "TB-E7-008",
    "module": "Taalbegrip",
    "difficulty": 205,
    "question": "Wat is een 'pleonasme'?",
    "options": ["Twee woorden die hetzelfde zeggen (bijv. 'witte sneeuw')", "Een vergelijking met 'als'", "Een overdrijving", "Een woord met twee betekenissen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-PLEONASME",
    "explanation": "Een pleonasme is dubbelop: 'witte sneeuw' (sneeuw is altijd wit), 'ronde cirkel' (een cirkel is altijd rond).",
    "distractorExplanations": {
      "1": "Dat is een vergelijking.",
      "2": "Dat is een hyperbool.",
      "3": "Dat is een homoniem."
    }
  },
  {
    "id": "TB-E7-009",
    "module": "Taalbegrip",
    "difficulty": 205,
    "question": "Lees de tekst:\n\n\"Wetenschappers hebben ontdekt dat olifanten rouwen om dode familieleden. Ze staan urenlang bij het lichaam en raken het aan met hun slurf. Soms komen ze zelfs jaren later terug naar de plek waar een familielid is gestorven.\"\n\nWelke conclusie kun je trekken?",
    "options": ["Olifanten hebben diepe emoties en een goed geheugen", "Olifanten zijn altijd verdrietig", "Olifanten begrijpen de dood niet", "Olifanten leven alleen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-CONCLUSIE-OLIFANT",
    "explanation": "Het rouwen wijst op diepe emoties. Het terugkomen na jaren wijst op een goed geheugen.",
    "distractorExplanations": {
      "1": "De tekst beschrijft specifiek rouwgedrag, niet constante verdrietigheid.",
      "2": "Het gedrag suggereert juist dat ze de dood wel begrijpen.",
      "3": "De tekst noemt 'familieleden', dus ze leven in groepen."
    }
  },
  {
    "id": "TB-E7-010",
    "module": "Taalbegrip",
    "difficulty": 205,
    "question": "Lees de tekst:\n\n\"In Finland gaan kinderen pas op hun zevende naar school. Toch scoren Finse leerlingen het hoogst op internationale toetsen. Het geheim? Veel buitenspelen, korte schooldagen en goed opgeleide leraren.\"\n\nWat is verrassend aan het Finse onderwijssysteem?",
    "options": ["Kinderen beginnen later maar scoren toch het hoogst", "Kinderen spelen nooit buiten", "De schooldagen zijn heel lang", "Leraren zijn slecht opgeleid"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-CONCLUSIE-FINLAND",
    "explanation": "Het signaalwoord 'toch' markeert de verrassing: later beginnen (verwachting: lagere scores) maar toch het hoogst scoren.",
    "distractorExplanations": {
      "1": "De tekst zegt juist 'veel buitenspelen'.",
      "2": "De tekst zegt 'korte schooldagen'.",
      "3": "De tekst zegt 'goed opgeleide leraren'."
    }
  }
]